document.addEventListener('click', (event) => {
  const tab = event.target.closest('.size-guide-modal__tab');
  if (!tab) return;

  const modal = tab.closest('.size-guide-modal');
  if (!modal) return;

  const target = tab.dataset.sizeGuideTab;

  modal.querySelectorAll('.size-guide-modal__tab').forEach((t) => {
    t.classList.toggle('size-guide-modal__tab--active', t === tab);
  });
  modal.querySelectorAll('.size-guide-modal__pane').forEach((pane) => {
    pane.classList.toggle('size-guide-modal__pane--active', pane.dataset.sizeGuidePane === target);
  });
});
